// extracted by mini-css-extract-plugin
module.exports = {"formOverview":"FormOverview_formOverview__2C0Gy","row":"FormOverview_row__1UVSO","icon":"FormOverview_icon__2mNIR","catPrefix":"FormOverview_catPrefix__1GNgv"};